import React, { useState } from "react";
import { useHistory, Prompt } from "react-router-dom";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import Editor from "ckeditor5-custom-build/build/ckeditor";
import { onReadyCKE, CKEconfig } from "../config/CKE";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import {
	Typography,
	Grid,
	Card,
	CardContent,
	Hidden,
	FormGroup,
	FormControlLabel,
	Switch,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { useSnackbar } from "notistack";
import SetFile from "../components/SetFile";

const useStyles = makeStyles((theme) => ({
	form: {
		width: "100%", // Fix IE 11 issue.
	},
	submit: {
		margin: theme.spacing(2, 0, 1),
	},
	CKElabels: {
		marginTop: "1.5rem",
		fontWeight: "bold",
	},
}));

export default function SitesAdd(props) {
	const classes = useStyles();
	const [site, setSite] = useState({});
	const [unsaved, setUnsaved] = useState(false);
	const { enqueueSnackbar } = useSnackbar();
	const history = useHistory();

	const onChange = (e) => {
		setSite({ ...site, [e.target.name]: e.target.value });
		setUnsaved(true);
	};

	const onChangePublished = (e) => {
		setSite({ ...site, [e.target.name]: e.target.checked });
		setUnsaved(true);
	};

	const onChangeDescription = (e, editor) => {
		const data = editor.getData();
		setSite({ ...site, description: data });
		setUnsaved(true);
	};

	const onChangeWarning = (e, editor) => {
		const data = editor.getData();
		setSite({ ...site, warning: data });
		setUnsaved(true);
	};

	const onSubmit = (e) => {
		e.preventDefault();
		fetch(`${process.env.REACT_APP_API_URL}/sites`, {
			method: "POST",
			credentials: "include",
			body: JSON.stringify(site),
			headers: { "Content-Type": "application/json" },
		})
			.then((res) => res.json())
			.then((data) => {
				if (data.success) {
					setUnsaved(false);
					enqueueSnackbar("Site added successfully!", { variant: "success" });
					history.push(`/${process.env.REACT_APP_ADMIN_URL}/sites`);
				} else {
					console.log(data);
					const errorArray = data.error.split(",");
					errorArray.forEach((error) => {
						enqueueSnackbar(`${error}`, { variant: "error" });
					});
				}
			});
	};

	return (
		<>
			<Prompt
				when={unsaved}
				message="You have unsaved changes. Are you sure you want to leave?"
			/>
			<form className={classes.form} onSubmit={onSubmit}>
				<Grid container spacing={2}>
					<Grid item xs={12} sm={12} md={9}>
						<Typography component="h1" variant="h4">
							Add a Site
						</Typography>
						<TextField
							variant="outlined"
							margin="normal"
							fullWidth
							id="name"
							label="Site Name"
							name="name"
							size="small"
							autoFocus
							onChange={onChange}
						/>
						<p className={classes.CKElabels}>Description*:</p>
						<CKEditor
							onReady={(editor) => {
								onReadyCKE(editor);
							}}
							editor={Editor}
							onChange={onChangeDescription}
							config={CKEconfig("Site description...")}
						/>
						<p className={classes.CKElabels}>Warning:</p>
						<CKEditor
							onReady={(editor) => {
								onReadyCKE(editor);
							}}
							editor={Editor}
							onChange={onChangeWarning}
							config={CKEconfig("Warning text (optional)...")}
						/>
						<Button
							type="submit"
							fullWidth
							variant="contained"
							color="primary"
							className={classes.submit}
						>
							Save
						</Button>
					</Grid>
					<Grid item xs={12} sm={12} md={3}>
						<Card>
							<CardContent>
								<Hidden smDown>
									<Button
										type="submit"
										onClick={onSubmit}
										fullWidth
										variant="contained"
										color="primary"
										className={classes.submit}
									>
										Save
									</Button>
								</Hidden>
								<FormGroup row>
									<FormControlLabel
										control={
											<Switch
												color="primary"
												checked={site.published ?? false}
												onChange={onChangePublished}
												name="published"
											/>
										}
										label={
											site.published ? (
												<Typography color="primary">Published</Typography>
											) : (
												<Typography color="secondary">Draft</Typography>
											)
										}
									/>
								</FormGroup>
								<SetFile
									fileTitle="Featured Image"
									resource={site}
									setResource={setSite}
									imageOnly={true}
									fileLabel="featuredImage"
									fileLabelFileName="featuredImageFile"
								/>
								<SetFile
									fileTitle="Banner Image"
									resource={site}
									setResource={setSite}
									imageOnly={true}
									fileLabel="bannerImage"
									fileLabelFileName="bannerImageFile"
								/>
								<SetFile
									fileTitle="Regions Image"
									resource={site}
									setResource={setSite}
									imageOnly={true}
									fileLabel="regionsImage"
									fileLabelFileName="regionsImageFile"
								/>
							</CardContent>
						</Card>
					</Grid>
				</Grid>
			</form>
		</>
	);
}
